import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from 'react-router-dom';

export default function PageNotFound() {
    return (
        <React.Fragment>
            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                    alignItems: 'center',
                    display: 'flex',
                    flexGrow: 1,
                    minHeight: '100vh'
                }}
            >
                <Container maxWidth={'sm'}>
                    <Typography variant="h1" paragraph>
                        404
                    </Typography>

                    <Typography variant="h3" paragraph>
                        Desculpe, página não encontrada!
                    </Typography>

                    <Typography sx={{ color: 'text.secondary' }} paragraph> 
                        Não encontramos a página que você está procurando. Talvez você tenha digitado errado o endereço? Certifique-se de verificar se não existe erro de ortografia.
                    </Typography>
                    <Button to="/" size="large" variant="contained" component={RouterLink}>
                        retornar para o login
                    </Button>
                </Container>
            </Box>
        </React.Fragment>

    )
}